import { COMPARISON_PAGES } from '../components/comparisons/comparisonConfigs';
import { COMPATIBILITY_PAGES } from '../components/compatibility/compatibilityPageConfigs';
import { gearPath } from './gearCatalog';

export const SITE_PAGES = [
  ['/', 'Angler Built', 'Fishing gear, deals, comparisons and tools'],
  ['/price-comparison', 'Fishing gear prices & deals', 'Compare prices across affiliate retailers. Batteries, sonar, shelters, augers and more.'],
  ['/ice-fishing', 'Ice fishing', 'New ice gear, brand guides and prices'],
  ['/ice-fishing/new-gear-2026-27', 'New ice fishing gear 2026–27', 'Discover new and updated releases'],
  ['/ice-fishing/clam-new-gear-2026-27', 'Clam new gear 2026–27 guide', 'Pack System, shelters, IceArmor, rods and tackle'],
  ['/ice-fishing/eskimo-new-gear-2026-27', 'Eskimo new gear 2026–27 guide', 'Shelters, E-Connect, hauling gear and apparel'],
  ['/ice-fishing/shows', 'Ice fishing show calendar', 'Expos, events, dates, locations and tickets'],
  ['/compare', 'Compare fishing electronics', 'LiveScope model differences and upgrade comparisons'],
  ['/compatibility', 'Garmin LiveScope compatibility', 'Find displays and transducers that work together'],
  ['/custom-builder', 'Custom Bundle Builder', 'Build a boat or ice fishing electronics setup'],
  ['/quick-bundles', 'Quick bundles', 'Ready to build fish finder setups'],
  ['/compare-screens', 'Garmin Screen Finder', 'Compare fish finders and chartplotter displays'],
  ['/compare-screens-v2', 'Garmin display comparison', 'Choose and compare screen specifications'],
  ['/select/battery', 'Battery Finder', 'Choose lithium battery capacity and chemistry'],
  ['/fgtn', 'Fishing Gear & Tech News shows', 'FGTN weekly episodes and product coverage'],
  ['/contact', 'Contact Angler Built', 'Get in touch with Alex Timm'],
  ['/ask-question', 'Ask a question', 'Questions, feedback and ideas'],
  ['/early-access', 'LiveScope Builder early access', 'Join the beta notification list'],
].map(([path, title, description]) => ({ path, title, description, type: 'Page' })).concat(
  COMPARISON_PAGES.map(p => ({ path: p.path, title: p.documentTitle.replace(/\s*\|.*$/, ''), description: 'Electronics comparison and upgrade guide', type: 'Comparison' })),
  COMPATIBILITY_PAGES.map(p => ({ path: p.path, title: p.question, description: p.framing, type: 'Compatibility' }))
);

export const searchTerms = value => String(value || '').normalize('NFKD').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/).filter(Boolean);
export function matchesSearch(text, query) {
  const haystack = searchTerms(text).join(' ');
  return searchTerms(query).every(term => haystack.includes(term));
}
export function searchSitePages(query, episodes = []) {
  if (!searchTerms(query).length) return [];
  const pages = [...SITE_PAGES, ...episodes.map(e => ({ path: `/fgtn/${e.episode_number}`, title: `FGTN ${e.episode_number}: ${e.title}`, description: 'Fishing Gear & Tech News episode', type: 'Show' }))];
  return pages.filter(p => matchesSearch(`${p.title} ${p.description}`, query));
}
export function searchSuggestions(products, pages, query) {
  if (searchTerms(query).join('').length < 2) return [];
  const matches = products.filter(p => matchesSearch(`${p.brand} ${p.name} ${p.category} ${p.searchTerms || ''}`, query));
  matches.sort((a, b) => (a.featured || 999) - (b.featured || 999) || a.name.localeCompare(b.name));
  return [...matches.slice(0, 5).map(p => ({ path: gearPath(p), title: p.name.toLowerCase().startsWith(p.brand.toLowerCase()) ? p.name : `${p.brand} ${p.name}`, type: 'Product' })), ...pages.slice(0, 3)].slice(0, 8);
}
